import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@mui/material";
import { useState } from "react";

type Props = {
    open: boolean;
    onClose: () => void;
};

export default function LicenseLookupDialog({
    open,
    onClose,
}: Props) {
    const [licence, setLicence] = useState("");
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                Rechercher par licence
            </DialogTitle>

            <DialogContent>
                <TextField
                    fullWidth
                    margin="normal"
                    label="Numéro de licence"
                    value={licence}
                    inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 6,
                    }}
                    onChange={(e) =>
                        setLicence(
                            e.target.value
                                .replace(/\D/g, "") // retire tout sauf les chiffres
                                .slice(0, 6)        // max 6 caractères
                        )
                    }
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    Annuler
                </Button>

                <Button
                    variant="contained"
                    color="error"
                    disabled={licence.length !== 6}
                >
                    Ajouter
                </Button>
            </DialogActions>
        </Dialog>
    );
}